/**
 * PageHeader — the standard page title (+ optional subtitle).
 *
 * One definition of the page-title type scale, shared across student, teacher
 * and admin. Pages that also have a tab row can use PageTabs, which is this
 * header plus a TabStrip.
 *
 * Deliberately not used by the Home greeting ("Hi <name> 👋"), which carries
 * its own heavier treatment.
 */

import type { ReactNode } from 'react';
import './PageHeader.css';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Right-aligned actions on the title row (buttons, filters). */
  actions?: ReactNode;
  /** Page-specific layout only — margins, alignment. */
  className?: string;
}

export function PageHeader({ title, subtitle, actions, className }: PageHeaderProps) {
  return (
    <header className={`page-header ${className ?? ''}`.trim()}>
      <div className="page-header-text">
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </header>
  );
}
